/*    
<summary>
   This functional common component provides us custom input box that allows only regex-valid values, 
   and formats numbers with commas when not focused.
   Developer:Aashish Singh, Updated Date:03-Sep-2025
</summary>
<returns>Returns JSX</returns>
*/
import React, { useState } from "react";
import { injectIntl } from "react-intl";
import { useField } from "formik";
import FormikFormErrorHandler from "./FormikFormErrorHandler";
import FormikRelayInfoFormErrorHandler from "./FormikFormRelayErrorHandler";
import { toHalfWidth } from "../../helpers/validate-helper";

interface IProps {
  children: React.ReactNode;
  className: string;
  errclassname: string | undefined;
  "data-testid"?: string;
  intl: any; // IntlConfig;
  name: string;
  onBlur: () => void;
  onChange: () => void;
  placeholder: string;
  type: string;
  value: string;
  toLowerCase: boolean;
  disabled: boolean;
  readOnly: boolean;
  spaceAllowed: boolean;
  validcharacter?: Array<string>;
  invalidcharacter?: Array<string>;
  setLocalState?: (id: any) => void;
  setState?: React.Dispatch<React.SetStateAction<any>>;
  regex: RegExp;
}

const FormikFormInputRegexCheckFormattedNumber = (props: IProps) => {
  const [field, meta, helpers] = useField(props);
  const [isFocused, setIsFocused] = useState(false);

  const errorClass = `${meta.error && meta.touched ? "error" : ""}`;
  const _placeholder = props.placeholder
    ? props.intl.formatMessage({ id: props.placeholder })
    : props.placeholder;

  // Value shown in input
  const displayValue =
  !isFocused &&
  field.value !== undefined &&
  field.value !== null &&
  field.value !== "" &&
  !isNaN(Number(field.value))
    ? new Intl.NumberFormat("en-US").format(Number(field.value)) // commas
    : field.value ?? "";

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let value = event.target.value.replace(/,/g, ""); // strip commas
    if (props.toLowerCase) value = value.toLowerCase();

    if (props?.regex?.test(value)) {
      helpers.setValue(value);
      if (props.setState) props.setState(value);
      if (props.setLocalState) props.setLocalState(value);
    } else {
      event.preventDefault();
    }
  };

  return (
    <>
      <input
        {...field}
        {...props}
        value={displayValue}
        placeholder={_placeholder}
        className={props.className + " " + errorClass}
        disabled={props.disabled}
        type={props.type}
        readOnly={props.readOnly}
        onFocus={() => setIsFocused(true)}
        onBlur={(e) => {
          setIsFocused(false);
          handleChange(e);
        }}
        onChange={handleChange}
      />
      {props.errclassname != undefined ||
      props.className == "relay_max_character_error" ? (
        <FormikRelayInfoFormErrorHandler intl={props.intl} meta={meta} />
      ) : (
        <FormikFormErrorHandler intl={props.intl} meta={meta} />
      )}
    </>
  );
};

export default injectIntl(FormikFormInputRegexCheckFormattedNumber);
